let isEditor = false;

if (window.FEGOEditor) {
    // 是否为编辑器
    isEditor = true;
}

/**
 * 判断H5还是Web模式
 * @returns
 */
 function isPcMode() {
    if(isEditor) {
        return parseInt(FEGOEditor.app.project.route.now.pageType, 2) === 2;
    } else {
        return parseInt(FEGORender.store.route.now.pageType, 2) === 2;
    }
}
/**
 * 防抖
 * @param {function} fn fn
 * @param {number} wait 延迟
 * @return {function} fn
 */
function debounce(fn, wait = 200) {
    let timer = null; //借助闭包
    return (...args) => {
        const f = () => fn(...args);
        if (timer) {
            clearTimeout(timer);
            timer = setTimeout(f, wait);
        } else {
            timer = setTimeout(f, wait);
        }
    };
}

export {
    isEditor,
    debounce,
    isPcMode
}



// WEBPACK FOOTER //
// ./src/fego/utils.js